module.exports = __webpack_public_path__ + "98fdf95fa225e55abf8bc7cf27499378.pdf";